/*
Site Video
*/
if (!window.customElements.get('site-video')) {
  class SiteVideo extends HTMLElement {
    connectedCallback () {
      this.videoWrapper = this.closest('[data-video-wrapper]')
      if (this.dataset.skipObserve !== 'true') {
        if (this.dataset.stopOnObserve === 'true') {
          this.stopOnObserve()
        } else {
          this.startOnObserve()
        }
      }

      if (this.dataset.playOnSlide === 'true') {
        this.handleSlider()
      }

      this.playBtn = this.querySelector('[data-play-btn]')
      this.video = this.querySelector('video')
      this.video?.addEventListener('click', () => {
        if (this.video.paused) {
          this.video.play()
        } else {
          this.video.pause()
        }
      })

      this.customControlsPlay = this.querySelector('[data-video-controls-play]')
      this.customControlsPlay?.addEventListener('click', this.togglePlay.bind(this))
      const dataDetachObserver = this.dataset.detachObserver === 'true'
      let detachFirstTime = true
      if (dataDetachObserver === true && detachFirstTime === true) {
        this.customControlsPlay?.addEventListener('click', () => {
          detachFirstTime = false
          this.detachVideoObserver()
        })
      }

      this.customControlsSound = this.querySelector('[data-video-controls-sound]')
      this.customControlsSound?.addEventListener('click', this.toggleMute.bind(this))

      this.video?.addEventListener('ended', () => {
        this.playBtn?.classList.add('is-Hidden')
      })

      this.video?.addEventListener('pause', () => {
        this.playBtn?.classList.remove('is-Hidden')
        this.classList.remove('is-Playing')
      })

      this.video?.addEventListener('play', () => {
        this.playBtn?.classList.add('is-Hidden')
        this.pauseAllVideos()
        this.classList.add('is-Playing')
      })
      this.playBtn?.addEventListener('click', this.togglePlay.bind(this))

      window.addEventListener('resize', this.playVideoForViewport.bind(this))
      if (this.dataset.autoplay === 'true') {
        this.playVideoForViewport()
      }
    }

    pauseAllVideos () {
      this.videoWrapper?.querySelectorAll('video').forEach((video) => {
        if (video !== this.video) {
          video.pause()
        }
      })
    }

    togglePlay () {
      if (this.video.paused) {
        this.video.play()
      } else {
        this.video.pause()
      }
    }

    stopOnObserve () {
      if ('IntersectionObserver' in window) {
        const videoObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach((video) => {
            const $video = video.target
            if (!video.isIntersecting) {
              $video.pause()
            }
          })
        })
        if (videoObserver) {
          videoObserver.observe(this.querySelector('video'))
        }
      }
    }

    startOnObserve () {
      if ('IntersectionObserver' in window) {
        const videoObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach((video) => {
            const $video = video.target
            const forceAutoplay = this.dataset.forceAutoplay === 'true'
            if (video.isIntersecting) {
              if ($video.readyState === 4 || forceAutoplay) {
                $video.play()
              } else {
                [].slice.call($video.querySelectorAll('source')).forEach((source) => {
                  if (source.dataset.src) {
                    source.src = source.dataset.src
                  }
                })
                $video.load()
              }
            } else {
              if (!$video.paused) {
                $video.pause()
              }
            }
          })
        })
        if (videoObserver) {
          videoObserver.observe(this.querySelector('video'))
          this._videoObserver = videoObserver
        }
      }
    }

    detachVideoObserver () {
      if (this._videoObserver) {
        this._videoObserver.disconnect()
        this._videoObserver = null
      }
    }

    play () {
      this.video.play()
    }

    pause () {
      this.video.pause()
    }

    playVideoForViewport () {
      const desktopVideo = this.querySelector('.js-desktop-video')
      const mobileVideo = this.querySelector('.js-mobile-video')

      if (window.innerWidth >= 900) {
        if (desktopVideo) {
          if (this.dataset.autoplay === 'true') {
            desktopVideo.play()
          }
          if (mobileVideo) mobileVideo.pause()
        }
      } else {
        if (mobileVideo) {
          if (this.dataset.autoplay === 'true') {
            mobileVideo.play()
          }
          if (desktopVideo) desktopVideo.pause()
        }
      }
    }

    handleSlider () {
      this.slider = this.closest('site-carousel')
      this.parentSlide = this.closest('.swiper-slide')
      this.slider?.addEventListener('slideChange', () => {
        setTimeout(() => {
          if (this.parentSlide.classList.contains('swiper-slide-active')) {
            this.play()
          } else {
            this.pause()
          }
        }, 100)
      })
    }

    toggleMute () {
      this.video.muted = !this.video.muted
      // Update classes for styling
      if (this.video.muted) {
        this.classList.add('is-Muted')
      } else {
        this.classList.remove('is-Muted')
      }
    }
  }

  customElements.define('site-video', SiteVideo)
}
